// extracted by mini-css-extract-plugin
export default {"container":"ifYQ_V","gridSmall":"MTHP49","carousel":"o9mbuG","gridDetailed":"esKeDe"};